import i18n from '@/localisation/i18n';
import useToastStore from '@/store/toast';
import clsx from 'clsx';
import { Link } from 'react-router-dom';

export const ItemTab = ({
  title,
  subtitle,
  id,
  isBlocked,
  unread,
}: {
  title: string;
  subtitle: string;
  id: string;
  isBlocked: boolean;
  unread: number;
}) => {
  const addToast = useToastStore(state => state.addToast);

  return (
    <Link
      className={clsx(
        'bg-card relative flex h-36 w-full max-w-[450px] justify-between rounded-lg',
        isBlocked && 'opacity-60'
      )}
      onClick={e => {
        if (isBlocked) {
          e.preventDefault();

          addToast(i18n.t('message.tab.locked'), 'lock');
        }
      }}
      to={id}
    >
      <div className="px-4 py-3">
        <h3 className="mb-1">{title}</h3>
        <h5 className="text-additional text-xs">{subtitle}</h5>
      </div>
      <img src={`/images/${id}.svg`} alt="item" />
      {unread > 0 && (
        <div className="bg-orange absolute bottom-3 left-4 flex h-[34px] w-11 items-center justify-center rounded-lg text-xs font-bold text-black">
          +{unread}
        </div>
      )}
      {isBlocked && (
        <div className="absolute bottom-3 left-4 flex h-[34px] w-11 items-center justify-center rounded-lg bg-[#42404D]">
          <img src="/icons/lock.svg" alt="lock" />
        </div>
      )}
    </Link>
  );
};
